import { render, staticRenderFns } from "./orderFundExit.vue?vue&type=template&id=2b5d2ade&"
import script from "./orderFundExit.vue?vue&type=script&lang=js&"
export * from "./orderFundExit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports